/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');
const { inputBox: inputBoxEvent, dropMenu: dropMenuEvent } = require('components/config/event.json');
const tip = require('components/base/pop/tip');
const pop = require('components/base/pop/pop');

const ajaxHttp = require('appUtil/ajaxHttp');
const { apiPath } = require('appService/api');
const store = require('appVuex/store');
const { setBreadCrumb } = require('src/common/vuex/action/common');
const template = require('./comment-list.tpl');
const communityMixin = require('../community/communityMixin');
const methMinxin = require('../community/methMixin');
require('./comment-list.scss');

const ChargerComment = {
	mixins: [communityMixin,methMinxin],
	template,
	store,
	vuex: {
		actions: {
			setBreadCrumb,
		}
	},

	data() {
		return {
			thItems: ["充电点","用户","话题", "内容摘要","发布时间","评分","评论","点赞","操作"],
			thItemSort:[
				{
					txt:'充电点',
					isSort:0
				},
				{
					txt:'用户',
					isSort:0
				},
				{
					txt:'话题',
					isSort:0
				},
				{
					txt:'内容摘要',
					isSort:0
				},
				{
					txt:'发布时间',
					isSort:0
				},
				{
					txt:'评分',
					isSort:0
				},
				{
					txt:'评论',
					isSort:1,
					keys:'comment',
					sortVal:3
				},
				{
					txt:'点赞',
					isSort:1,
					keys:'like',
					sortVal:2
				},
				{
					txt:'操作',
					isSort:0
				},
			],
			url: apiPath.charge.commentList,

			model:'spotMark',
			modelQues:'spotQuestion',
			pageInitCt: 1,
			searchName:"chargerKey",
			placeItem:"按充电点关键字搜索",
			searchVal: "",
			topicTypeVal:"",
			hierarchyVal:"",

			sortTypeVal:"",
			sortList:[
				{value:"1", text:"正常排序"},
				{value:"2", text:"喜欢升序"},
				{value:"-2", text:"喜欢降序"},
				{value:"3", text:"评论升序"},
				{value:"-3", text:"评论降序"}
				
			],
			
			sortTypeVal:"",
			searchList: [
				{value:"chargerKey", text:"按充电点关键字"},
				{value:"userName", text:"按用户名"},
				{value:"userId", text:"按用户ID"},
				{value:"userPho",text:"按用户手机号"}
			],
			topicList: [
				{value:"",text:"全部话题"},
				{value:"1", text:"特斯拉充电点"},
				{value:"2", text:"国标充电点"},
				{value:"3",text:"全部充电点"}
			],
			hierarchyList:[
				{value:"",text:"全部帖子"},
				{value:"1", text:"精华帖"},
				{value:"2", text:"置顶帖"}
			]
		}
	},
	ready(){

	},
	methods: {

		searchData() {
			this.$refs.tableData.query({
				"startTime":this.calendar.items.startTime.value,
				"endTime":this.calendar.items.endTime.value,
				"searchName":this.searchName,
				"searchVal":this.searchVal,
				"topicType":this.topicTypeVal,
				"hierarchy":this.hierarchyVal,
				"sortType":this.sortTypeVal
			}).fetch();
		},
		sortTableCall(idx,stas){
      let _val = this.thItemSort[idx].sortVal;
      let _sortVal = stas==0? 1 : stas==1? _val :(0-_val);
      this.sortTypeVal = _sortVal;
      this.searchData();

    }
	},
	events:{
		[dropMenuEvent.menu.change](selecObj){
			console.log(selecObj);
			this.calendar.show = false;
			let queryName = selecObj.queryName;
			console.log(this.searchVal);
			if(queryName === 'searchName'){
				this.searchName = selecObj.value;
				this.placeItem = selecObj.text;
				return;
			}
			this[queryName] = selecObj.value;
			this.searchData();
		},
		[inputBoxEvent.change](obj){
				let inputName = obj.queryName;
				if(inputName === 'searchInput'){
					this.searchVal = obj.value
				}
		}
	},

	components:{
		pop
	}
}

module.exports = ChargerComment;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/community/charger-comment/comment-list.js